// src/utils/imageUrl.js
const API_SUFFIX_PATTERN = /\/api(?:\/v\d+)?\/?$/i;

export function getServerBaseUrl() {
  const apiUrl = (import.meta.env.VITE_API_URL || '/api/v1').trim();
  return apiUrl.replace(API_SUFFIX_PATTERN, '').replace(/\/$/, '');
}

export function getImageUrl(relativePath) {
  if (!relativePath || typeof relativePath !== 'string') return null;

  const path = relativePath.trim();

  if (/^(https?:|blob:|data:)/i.test(path)) return path;

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const serverBase = getServerBaseUrl();

  return `${serverBase}${cleanPath}`;
}